import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Clock from 'react-digital-clock';
import Rodal from 'rodal';
import { connect } from 'react-redux';

import store from '../redux/store.js';
import { changeBackground } from '../redux/actions.js';
import '../App.css';
import windows from '../assets/windows.png';
import windowsBlue from '../assets/windows_blue.png';
import bliss from '../assets/bliss.jpg';
import landscape from '../assets/landscape.jpg';
import mountains from '../assets/mountains.jpg';


function BottomBar(props) {
  const [show, setShow] = useState(false);
  const [hoverWindows, setHoverWindows] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return(
    <Provider store={store}>
      <Container fluid style={{position: 'absolute', left: 0, bottom: 0, height: '5vh', margin: 0, zIndex: 2000}}>
        <Row style={{textAlign: 'center', backgroundColor: '#070e15', height: '100%', alignContent: 'center'}}>
          <div onClick={handleShow} onMouseEnter={() => setHoverWindows(true)} onMouseLeave={() => setHoverWindows(false)}>
            <img src={hoverWindows ? windowsBlue : windows} alt='windows' style={{height: '5vh', padding: 10, marginLeft: 10, marginRight: 10}} />
          </div>
          <div className='verticalDivider' />
          <div style={{color: 'white', position: 'absolute', right: '100px'}}>
            ENG
          </div>
          <div className='clock'>
            <Clock hour12={false} />
          </div>
        </Row>
      </Container>
      
      <Rodal visible={show} onClose={handleClose} animationType={"zoom"} closeMaskOnClick={true} showMask={true} closeOnEsc={true}>
        <Container fluid>
          <Row>
            Choose your background
          </Row>
        </Container>
        <Container style={{height: '90%'}}>
          <Row style={{height: '100%', alignItems: 'center'}}>
            <Col>
              <Card style={{width: 90, height: 80}} onClick={() => {handleClose(); props.changeBackground('bliss'); }}>
                <Card.Img src={bliss} style={{margin: 2, width: '100%', height: '100%'}}/>
              </Card>
            </Col>
            <Col>
              <Card style={{width: 90, height: 80}} onClick={() => {handleClose(); props.changeBackground('landscape'); }}>
                <Card.Img src={landscape} style={{margin: 2, width: '100%', height: '100%'}}/>
              </Card>
            </Col>
            <Col>
              <Card style={{width: 90, height: 80}} onClick={() => {handleClose(); props.changeBackground('mountains'); }}>
                <Card.Img src={mountains} style={{margin: 2, width: '100%', height: '100%'}}/>
              </Card>
            </Col>
          </Row>
        </Container>
      </Rodal>
    </Provider>
  )
}

export default connect(
  null,
  { changeBackground }
)(BottomBar);
